import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type Address } from '../../../../../../src/types/Address';
export { type Address };

export async function getApiV2CustomersCustomerIdAddress() {
  return await send<Address>({
    path: `/api/v2/customers/self/address/`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
